import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const DevexPhasingChart = ({ data }) => {
  // Auto-extend to show all years with activity (minimum 10 years)
  const displayYears = Math.max(10, data.length);
  const chartData = data.slice(0, displayYears).map((value, index) => ({
    year: `Year ${index + 1}`,
    devex: value / 1000000 // Convert to millions
  }));

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-white p-3 border border-emerald-300 rounded shadow-lg">
          <p className="font-semibold" style={{ color: '#2C3E50' }}>{payload[0].payload.year}</p>
          <p className="text-emerald-700">
            DEVEX: £{payload[0].value.toFixed(2)}m
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={chartData} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="#d1fae5" />
        <XAxis 
          dataKey="year" 
          tick={{ fill: '#2C3E50', fontSize: 12, fontFamily: 'Lato, sans-serif' }}
          angle={-45}
          textAnchor="end"
          height={80}
        />
        <YAxis 
          tick={{ fill: '#2C3E50', fontSize: 12, fontFamily: 'Lato, sans-serif' }}
          label={{ value: 'DEVEX (£m)', angle: -90, position: 'insideLeft', fill: '#2C3E50', fontFamily: 'Lato, sans-serif' }}
        />
        <Tooltip content={<CustomTooltip />} />
        <Bar dataKey="devex" fill="#388E3C" radius={[8, 8, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default DevexPhasingChart;
